export default {
  namespaced: true,
  state: () => {
    return {
      topMenuData: null
    }
  },
  mutations: {
    setTopMenuData(state, data) {
      state.topMenuData = data
    },
    clearTopMenuData(state) {
      state.topMenuData = null
    }
  },
  actions: {
    setTopMenuData({ commit }, data) {
      commit('setTopMenuData', data)
    },
    clearTopMenuData({ commit }) {
      commit('clearTopMenuData')
    }
  },
  getters: {
    getTopMenuData: (state) => state.topMenuData
  }
};
